import {
  Component,
  inject,
  signal,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { BusinessContextService } from '../../../core/services/multi-tenant/business-context.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-past-due-banner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterLink, MatIconModule],
  template: `
    @if (visible()) {
      <div class="past-due-banner">
        <div class="past-due-banner__content">
          <mat-icon class="past-due-banner__icon">warning</mat-icon>
          <span class="past-due-banner__text">
            Tu pago está pendiente. Actualiza tu método de pago para evitar la suspensión.
          </span>
          <a routerLink="/settings/subscription" class="past-due-banner__link">Actualizar Pago</a>
        </div>
        <button class="past-due-banner__close" (click)="dismiss()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
  `,
  styles: [
    `
      .past-due-banner {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.5rem 1rem;
        background: var(--color-warning-bg);
        border-bottom: 2px solid var(--color-warning);
        color: var(--color-warning-text, var(--color-text-primary));

        &__content {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          flex: 1;
          flex-wrap: wrap;
        }

        &__icon {
          color: var(--color-warning);
          font-size: 20px;
          width: 20px;
          height: 20px;
        }

        &__text {
          font-size: 0.875rem;
          font-weight: 500;
        }

        &__link {
          font-size: 0.875rem;
          font-weight: 600;
          color: var(--color-warning);
          text-decoration: underline;
          white-space: nowrap;

          &:hover {
            opacity: 0.8;
          }
        }

        &__close {
          background: none;
          border: none;
          cursor: pointer;
          padding: 0.25rem;
          display: flex;
          align-items: center;
          color: var(--color-text-secondary);

          mat-icon {
            font-size: 18px;
            width: 18px;
            height: 18px;
          }

          &:hover {
            color: var(--color-text-primary);
          }
        }
      }
    `,
  ],
})
export class PastDueBannerComponent implements OnInit, OnDestroy {
  private businessContext = inject(BusinessContextService);
  private sub?: Subscription;

  isPastDue = signal(false);
  dismissed = signal(false);

  visible = () => this.isPastDue() && !this.dismissed();

  ngOnInit(): void {
    this.sub = this.businessContext.currentBusiness$.subscribe(business => {
      this.isPastDue.set(business?.subscription?.status === 'past_due');
      // Reset dismissal if status changes (e.g., went back to active then past_due again)
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  dismiss(): void {
    this.dismissed.set(true);
  }
}
